import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppTableComponent } from './app-table.component';
import { SharedModule } from '../../shared.module';
import { FormsModule } from '@angular/forms';
import { DetailViewsModule } from '../detail-views/detail-views.module';



@NgModule({
  declarations: [AppTableComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    DetailViewsModule
  ],
  exports: [
    AppTableComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppTableModule { }
